export type Rng = {
  readonly seed: string;
  float(): number;
  int(minInclusive: number, maxExclusive: number): number;
  range(min: number, max: number): number;
  pick<T>(items: readonly T[]): T;
  chance(probability: number): boolean;
  fork(label: string): Rng;
};

function hashSeed(seed: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  h ^= h >>> 16;
  return h >>> 0;
}

function mulberry32(state: number): () => number {
  let a = state >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function createRng(seed: string): Rng {
  const next = mulberry32(hashSeed(seed));
  return {
    seed,
    float: next,
    int(minInclusive, maxExclusive) {
      return minInclusive + Math.floor(next() * (maxExclusive - minInclusive));
    },
    range(min, max) {
      return min + next() * (max - min);
    },
    pick<T>(items: readonly T[]): T {
      const value = items[Math.floor(next() * items.length)];
      if (value === undefined) throw new Error('rng.pick: empty list');
      return value;
    },
    chance(probability) {
      return next() < probability;
    },
    fork(label) {
      return createRng(`${seed}/${label}`);
    },
  };
}

export function dailySeed(date: Date = new Date()): string {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `solta-${y}${m}${d}`;
}
